// extracted by mini-css-extract-plugin
export default {"area":"Cookies_area__28OYf","header":"Cookies_header__GvpTw","content":"Cookies_content__TM92k"};